export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export interface ColumnSortModel<ColumnNames> {
  colId: ColumnNames;
  sort: SortOrder;
}
